export default {"src":"/_next/static/media/Camera.917c2440.svg","height":24,"width":24};